import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'

import Typography from '@material-ui/core/Typography'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { Avatar, createStyles, Grid, makeStyles, Theme } from '@material-ui/core'
import dailyDoseImage from '../../assets/images/daily_dose_icon.png'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  })
)

export interface IWelcomeMessageModalProps {
  onClose: () => void
  open: boolean
}

export const WelcomeMessageModal = ({
  onClose,
  open,
}: IWelcomeMessageModalProps) => {
  const classes = useStyles()
  return (
    <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle id="customized-dialog-title">
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item>
            <Avatar src={dailyDoseImage} className={classes.small} />
          </Grid>
          <Grid item xs={'auto'}>
            <Typography variant="inherit" color="primary" align="center">
              Welcome!
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Grid
          container
          direction="column"
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item container justify="center">
            <Typography variant="body1" color="textSecondary" align="center">
              The Daily Dose is about all the greatest pleasures and smallest joys in
              life.
            </Typography>
          </Grid>
          <Grid item container justify="center">
            <Typography variant="subtitle1" color="textPrimary">
              What is the Daily Dose?
            </Typography>
            <Typography variant="body1" color="textSecondary" align="center">
              A collection of thoughts, memories, moments, and feelings.
            </Typography>
          </Grid>
          <Grid item container justify="center">
            <Typography variant="subtitle1" color="textPrimary">
              How does the Daily Dose work?
            </Typography>
            <Grid container direction="column" justify="center" alignItems="center">
              <Typography variant="body1" color="textSecondary">
                1. Create a group.
              </Typography>
              <Typography variant="body1" color="textSecondary">
                2. Invite members.
              </Typography>
              <Typography variant="body1" color="textSecondary">
                3. Add doses.
              </Typography>
              <Typography variant="body1" color="textSecondary">
                4. A new dose will be out daily.
              </Typography>
              <Typography variant="body1" color="textSecondary">
                5. Enjoy! 😍
              </Typography>
            </Grid>
          </Grid>
          <Grid item container justify="center">
            <Typography variant="subtitle1" color="textPrimary" align="center">
              Why the Daily Dose?
            </Typography>
            <Typography variant="body1" color="textSecondary" align="center">
              Reduce anxiety and worry. Increase creativity, gravity, and positivity.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" color="textSecondary" align="center">
              Increase your capacity for positivity, curiosity, and gratitude. New
              doses every day.
            </Typography>
          </Grid>
          <Grid item container justify="center">
            <Typography variant="body1" color="textSecondary" align="center">
              The world is filled with enjoyable things, and we all see these
              different things in different ways. Sharing your happiness with others
              is invaluable and contagious.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary" variant="text">
          Ok, start dozing 😍
        </Button>
      </DialogActions>
    </Dialog>
  )
}
